<template>
  <teleport to="body">
    <TransitionRoot
      enter="ease-in-out duration-150"
      enter-from="opacity-0"
      enter-to="opacity-100"
      leave="ease-in-out duration-150"
      leave-from="opacity-100"
      leave-to="opacity-0"
      as="template"
      appear
      :show="generalInternalStore.systemOverlay"
    >
      <div class="fixed z-[999] top-0 inset-0 bg-black/60 transition-opacity" />
    </TransitionRoot>
  </teleport>
</template>

<script setup lang="ts">
import { TransitionRoot } from "@headlessui/vue";

const generalInternalStore = useGeneralInternalStore();
</script>
